import { render, staticRenderFns } from "./TradeInPopin.vue?vue&type=template&id=c6b1af16&scoped=true&"
import script from "./TradeInPopin.vue?vue&type=script&lang=js&"
export * from "./TradeInPopin.vue?vue&type=script&lang=js&"
import style0 from "./TradeInPopin.vue?vue&type=style&index=0&id=c6b1af16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b1af16",
  null
  
)

export default component.exports